//@ts-nocheck
import React from "react";
import Box from "@mui/material/Box";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { StyledIconButton } from "../../components/StyledComponents/Buttons/AuradineButtons.js";
import { SecondaryButton } from "../../components/StyledComponents/Buttons/AuradineButtons.js";
import { CaseManagementActionsTab } from "./CaseManagementOperationsTab.js";
import { Tooltip, Chip } from "@mui/material";
import { set } from "lodash";

import useMinerPageContext from "../../minerstatusV2/context/useMinerPageContext.js";
import {
  BodyLarge,
  H8TitleMedium,
} from "../../components/StyledComponents/Typography/Typography.tsx";

export const CaseManagementOperationsContainer = React.memo(
  (props) => {
    const {
      refetch,
      resetTableSelection,
      setTableKey,
      user,
      selectedCases,
      caseData,
    } = props;

    const { role } = user ? user : {};

    const hasSelectedCases =
      Array.isArray(selectedCases) &&
      selectedCases.length > 0;

    // For Case Management, enable actions when rows are selected
    const isDisabled = !hasSelectedCases;



    let caseManagementLabel = "";
    if (!hasSelectedCases) {
      caseManagementLabel = "all cases";
    } else if (hasSelectedCases) {
      const plural =
        selectedCases.length === 1 ? "case" : "cases";
      caseManagementLabel = `${selectedCases.length} selected ${plural}`;
    }

    return (
      <Box
        className={"table-operations-container"}
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Box
          className={"table-operations-container-left"}
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          maxWidth="100%"
        >

        </Box>

        <Box
          className={"table-operations-container-right"}
          display={"flex"}
          flexDirection={"row"}
          gap={2}
        >

          <CaseManagementActionsTab
            refetch={refetch}
            setTableKey={setTableKey}
            role={role}
            selectedCases={selectedCases}
            caseData={caseData}
            user={user}
          />
        </Box>
      </Box>
    );
  }
);
